// const baseUrl='http://localhost:8000'
const baseUrl = "https://appapi.oncloudapi.com";
// const baseUrl = "http://192.168.100.7:8000/proshelf";
// const baseUrl = "http://37.27.12.155:8000/proshelf";
// const baseUrl = "http://192.168.1.12:8000/proshelf";

export default {
  baseUrl: baseUrl, 
};
